import React, { memo, useCallback, useEffect, useState } from "react";
import { Header } from "./EnvironmenrConstants/Header";
import { StaticText } from "./EnvironmenrConstants/StaticText";
import { Grid, Typography, Box, Tooltip, Chip } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Badge from "@mui/material/Badge";
import Link from "@mui/material/Link";
import { SetUpTable } from "./EnvironmenrConstants/SetupTable";
import MUIDataTable from "mui-datatables";
import Button from "@mui/material/Button";
import DataSerices from "../Services/DataSerices";
import BackDropLoading from "../Components/Loading";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";

const EnvironmentalSetUp = ({ loader, messageBack, ifchild }) => {
  const [list, setList] = useState([]);
  const [loaderSetup, setloaderSetup] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isEditing, setIsEditing] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 6,
  };

  const [editMode, setEditMode] = useState(false);
  const [displayName, setdisplayName] = useState();
  const [updateDisplayName, setUpdateDisplayName] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [condo, setCondo] = React.useState("");
  const [dropVal, setDropVal] = React.useState([]);

  useEffect(() => {
    console.log("After saving - displayName:", updateDisplayName);
  }, [updateDisplayName]);

  const handleEditClick = (value, index, event) => {
    setEditMode(true);
    setEditingIndex(index);
    setAnchorEl(event.currentTarget);
    setdisplayName(list[index].displayName || "");
  };

  // const handleEsaveClick = (value,index) => {
  //   console.log("Before saving - displayName:", displayName);
  //   // setUpdateDisplayName(displayName);
  //   // setdisplayName(value)
  //   setEditMode(false);
  //   setAnchorEl(null);

  //   const handleEsaveClick = () => {
  //     console.log("Before saving - displayName:", displayName);
  //     // No need to setdisplayName(value) here
  //     setEditMode(false);
  //     setAnchorEl(null);
  //     console.log("After saving - displayName:", displayName);
  // };

  const handleEsaveClick = () => {
    console.log("Before saving - displayName:", displayName);

    const updatedList = [...list];
    const updatedItem = { ...updatedList[editingIndex] }; // Replace indexToUpdate with the correct index
    updatedItem.displayName = displayName; // Update displayName in the local copy of the data
    updatedList[editingIndex] = updatedItem;
    setList(updatedList);
    setEditMode(false);
    setAnchorEl(null);
    console.log("After saving - displayName:", displayName);
  };

  const handleCancelClick = () => {
    setEditMode(false);
    setAnchorEl(null);
  };

  const handleCheckboxChange = useCallback(
    (index, columnName) => {
      if (ifchild) {
        const updatedList = [...list];
        updatedList[index][columnName] = !updatedList[index][columnName];
        setList(updatedList);
      }
    },
    [list]
  );

  const channelLocation = {
    location: "gym lobby",
  };

  const handleSaveClick = async () => {
    loader(true);
    var datas = [];
    list.forEach((item, index) => {
      let apidata = {
        channel: item.channel,
        serviceName: item.serviceName,
        displayName: item.displayName,
        monitoring: {
          fallMonitoring: item.fallMonitoring,
          //fightMonitoring: item.fightMonitoring,
          illegalDumping: item.illegalDumping,
          illegalParking: item.illegalParking,
          loitering: item.loitering,
          maintenanceModelA: item.maintenanceModelA,
          maintenanceModelB: item.maintenanceModelB,
          maintenanceModelC: item.maintenanceModelC,
          maintenanceModelD: item.maintenanceModelD,
          maintenanceModelE: item.maintenanceModelE,
          peopleCountInsideGym: item.peopleCountInsideGym,
          peopleGathering: item.peopleGathering,
          perimeterMonitoring: item.perimeterMonitoring,
          pets: item.pets,
          //visitorCarLotTracking: item.visitorCarLotTracking,
        },
      };
      console.log("Datas Array:", datas);

      datas.push(apidata);
    });
    var response = await DataSerices.handleEnvSetup(datas);
    if (response.status < 250) {
      messageBack(true);
    } else {
      messageBack(false);
    }
    console.log(response);
    loader(false);
  };

  useEffect(() => {
    if (ifchild) {
      loader(true);
    } else {
      setloaderSetup(true);
    }
    const storedUserDetails = sessionStorage.getItem("userDetails");
    let userEmail = null;
    if (storedUserDetails) {
      const parsedUser = JSON.parse(storedUserDetails);
      userEmail = parsedUser.emailId;
      getEnviromentalDetails(userEmail);
    }
  }, []);
  useEffect(() => {
    const storedUserDetails = sessionStorage.getItem("userDetails");
    let userRole = null;
    if (storedUserDetails) {
      const parsedUser = JSON.parse(storedUserDetails);
      var dummy = [];
      parsedUser.organization.map((item, index) => {
        dummy.push({ value: item.orgCode, label: item.orgName });
      });
      setDropVal(dummy);
      setCondo(dummy[0].value);
    }
  }, []);

  const handlecondoChange = async (e) => {
    setCondo(e);
  };

  const getEnviromentalDetails = async (email) => {
    await DataSerices.environmentalSetup(email)
      .then((res) => {
        console.log("respkmkmkm...", res.data.response.body);
        if (res && res?.data && res?.data?.response?.body) {
          let details = res.data.response.body;
          setList(details);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        if (ifchild) {
          loader(false);
        } else {
          setloaderSetup(false);
        }
      });
  };

  const date = "20-21-2021";

  const columns = [
    {
      name: "id",
      label: "S/No.",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{tableMeta.rowIndex + 1}</span>;
        },
      },
    },
    {
      name: "channel",
      label: "Channel",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <span>{value}</span>
              <EditIcon
                style={{
                  fontSize: "15",
                  marginLeft: "4",
                  marginTop: "5px",
                  cursor: "pointer",
                }}
                onClick={(e) => handleEditClick(value, tableMeta.rowIndex, e)}
              />
              <Grid sx={{ ml: -2 }}>
                <Chip
                  label={` ${list[tableMeta.rowIndex].displayName || "N/A"}`}
                  size="small"
                />
              </Grid>
              <Popover
                open={editMode}
                anchorEl={anchorEl}
                onClose={handleCancelClick}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <div style={{ padding: "10px" }}>
                  <TextField
                    sx={{}}
                    label="Location Name"
                    variant="standard"
                    value={displayName}
                    onChange={(e) => setdisplayName(e.target.value)}
                  />
                  <Button onClick={handleEsaveClick}>Save</Button>
                  {/* <Button onClick={handleCancelClick}>Cancel</Button>   */}
                </div>
              </Popover>
            </div>
          );
        },
      },
    },
    // {
    //   name: "Alai Name",
    //   label: "Alai Name",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <TextField  variant='standard' type="text" color="success" focused sx={{ width:100}} onChange={() =>
    //           handleCheckboxChange(tableMeta.rowIndex, "Alai Name")
    //         }/>
    //       );
    //     },
    //   },
    // },
    {
      name: "illegalParking",
      label: "Illegal Parking",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "illegalParking")
              }
            />
          );
        },
      },
    },
    {
      name: "illegalDumping",
      label: "Illegal Dumping",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "illegalDumping")
              }
            />
          );
        },
      },
    },
    {
      name: "peopleCountInsideGym",
      label: "People Count Inside Gym",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "peopleCountInsideGym")
              }
            />
          );
        },
      },
    },
    {
      name: "perimeterMonitoring",
      label: "Perimeter Monitoring",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "perimeterMonitoring")
              }
            />
          );
        },
      },
    },
    {
      name: "loitering",
      label: "Loitering",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "loitering")
              }
            />
          );
        },
      },
    },
    {
      name: "pets",
      label: "Pets",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() => handleCheckboxChange(tableMeta.rowIndex, "pets")}
            />
          );
        },
      },
    },
    {
      name: "peopleGathering",
      label: "People Gathering",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "peopleGathering")
              }
            />
          );
        },
      },
    },
    {
      name: "fallMonitoring",
      label: "Fall Monitoring",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "fallMonitoring")
              }
            />
          );
        },
      },
    },
    /*{
      name: "fightMonitoring",
      label: "Fight Monitoring",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "fightMonitoring")
              }
            />
          );
        },
      },
    },
    {
      name: "visitorCarLotTracking",
      label: "Visitor Car Lot Tracking",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(
                  tableMeta.rowIndex,
                  "visitorCarLotTracking"
                )
              }
            />
          );
        },
      },
    },*/
    {
      name: "maintenanceModelA",
      label: "Maintenance ModalA",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "maintenanceModelA")
              }
            />
          );
        },
      },
    },
    {
      name: "maintenanceModelB",
      label: "Maintenance ModalB",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "maintenanceModelB")
              }
            />
          );
        },
      },
    },
    {
      name: "maintenanceModelC",
      label: "Maintenance ModalC",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "maintenanceModelC")
              }
            />
          );
        },
      },
    },
    {
      name: "maintenanceModelD",
      label: "Maintenance ModalD",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "maintenanceModelD")
              }
            />
          );
        },
      },
    },
    {
      name: "maintenanceModelE",
      label: "Maintenance ModalE",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              color="success"
              inputProps={{ "aria-label": "controlled" }}
              onChange={() =>
                handleCheckboxChange(tableMeta.rowIndex, "maintenanceModelE")
              }
            />
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const displayColor =
            value == "online"
              ? "success"
              : value == "offline"
              ? "error"
              : "warning";
          return (
            <Badge
              badgeContent={value}
              color={displayColor}
              sx={{ width: 20 }}
            />
          );
        },
      },
    },
    /*{
       name: "noOfImages",
       label: "Images Processed",
       options: {
         filter: false,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => {
                     
           return <Typography>{value}</Typography> 
         },
       },
     },*/
    {
      name: "webpage",
      label: "HealthCheck",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Grid>
              <Button
                sx={{
                  fontSize: "0.7rem",
                  padding: "1px 5px",
                  marginTop: "25px",
                }}
                onClick={handleOpen}
                variant="contained"
                size="xs"
              >
                View{" "}
              </Button>
              <Grid style={{ marginTop: "1px" }}>{date}</Grid>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Text in a modal
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Duis mollis, est non commodo luctus, nisi erat porttitor
                    ligula.
                  </Typography>
                </Box>
              </Modal>
            </Grid>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    selectableRows: false,
    search: false,
    serverSide: false,
    download: false,
    print: false,
    viewColumns: false,
    pagination: false,
  };
  console.log(sessionStorage.getItem("userRole"));

  return (
    <>
      {list ? (
        <Grid container spacing={2}>
          <Grid item xs={10} sm={10} md={10}>
            <Header title={StaticText.environmentalSetup} />
          </Grid>
          {sessionStorage.getItem("userRole") == "SUPERADMIN" && (
            <Grid item xs={2} sm={2} md={2} style={{ padding: `30px` }}>
              <TextField
                id="outlined-select-currency"
                select
                label="Condo Name"
                size="small"
                fullWidth
                value={condo}
                onChange={(e) => handlecondoChange(e.target.value)}
              >
                {dropVal.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}

          {loaderSetup && <BackDropLoading open={loaderSetup} />}

          <Grid item xs={12} sm={12} md={12}>
            <MUIDataTable data={list} columns={columns} options={options} />
          </Grid>
          {ifchild && (
            <Grid
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px",
              }}
              item
              xs={12}
              sm={12}
              md={12}
            >
              <Button variant="contained" onClick={handleSaveClick}>
                Save
              </Button>
            </Grid>
          )}
          {!ifchild && (
            <Grid
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px",
              }}
              item
              xs={12}
              sm={12}
              md={12}
            >
              <Grid>
                <Button onClick={handleOpen} variant="contained">
                  View Dashboard
                </Button>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Text in a modal
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      Duis mollis, est non commodo luctus, nisi erat porttitor
                      ligula.
                    </Typography>
                  </Box>
                </Modal>
              </Grid>
            </Grid>
          )}
        </Grid>
      ) : (
        <Typography textAlign="center" fontSize={30} color={"whitesmoke"}>
          {" "}
          Your Setup is being generated
        </Typography>
      )}
    </>
  );
};

export default memo(EnvironmentalSetUp);
